module.exports = __webpack_public_path__ + "static/media/korealog.9244ab99.png";